export const TEST_IDS = {
  MASONRY: 'section-grid-masonry',
  LINK: 'section-grid-item-link',
} as const;
